import { useId } from "react";

import { Stack, Switch, Typography } from "@mui/material";

import { UserSettingKey } from "@/api";
import { useUpdateUserSetting } from "@/common/hooks/useUpdateUserSetting";
import { useUserSettings } from "@/common/hooks/useUserSettings";
import { useTranslation } from "@/translations";

export function ClientFileColorCodingSetting() {
  const { t } = useTranslation();
  const { isLoading, isClientFileColorCodingOn } = useUserSettings();
  const { mutate: updateSetting, isPending } = useUpdateUserSetting();

  const titleId = useId();
  const hintId = useId();

  return (
    <Stack spacing={1.5} p={2} sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={2}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2" fontWeight={700} id={titleId}>
            {t("userSettings.clientFileColorCoding.title")}
          </Typography>
          <Typography variant="body2" color="text.secondary" id={hintId}>
            {t("userSettings.clientFileColorCoding.hint")}
          </Typography>
        </Stack>
        <Switch
          checked={isClientFileColorCodingOn}
          disabled={isLoading || isPending}
          onChange={(_, checked) => updateSetting({ key: UserSettingKey.ClientFileColorCoding, value: checked })}
          slotProps={{ input: { "aria-labelledby": titleId, "aria-describedby": hintId } }}
          sx={{ flexShrink: 0 }}
        />
      </Stack>
    </Stack>
  );
}
